import {ErrorHandler, Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class CustomErrorHandler implements ErrorHandler {
    public handleError(error: any) {
        if(!!error) {
            if (error instanceof Error) {
                throw error;
            }
            else {
                throw error;
            }
        }
    }
}
